import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';

import { createAction } from 'shared/util/utility';
import { EventAllDetailsDataState } from '../interface/sportPrematch';

export const fetchEventDetailData = (eventDet: EventAllDetailsDataState) => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		dispatch(
			createAction(actionTypes.FETCH_EVENT_DETAIL_DATA_SUCCESS, {
				event: eventDet.event,
				customeBets: eventDet.customeBets,
			}),
		);
	};
};

export const resetEventDetailData = () => {
	return async (dispatch: ThunkDispatch<{}, {}, Action>) => {
		dispatch(createAction(actionTypes.RESET_EVENT_DETAIL_DATA));
	};
};
